/**
 * @module ghVideo
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { API_BASE_URL } from "@/utils/conf";

@Component
export default class GhVideo extends Vue {
  @Prop()
  private source!: string;
  @Prop()
  private poster!: string;

  private url = API_BASE_URL + "api/files/";

  private get playerOptions() {
    let options = {
      ...this.playerOptionsTemplate,
      sources: [{ src: this.url + this.source, type: "video/mp4" }]
    };
    return options;
  }

  private playerOptionsTemplate = {
    //        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
    autoplay: true, // 如果true,浏览器准备好时开始回放。
    muted: false, // 默认情况下将会消除任何音频。
    loop: false, // 导致视频一结束就重新开始。
    preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
    language: "zh-CN",
    aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
    sources: [
      {
        type: "video/mp4",
        src: this.url + "5cb036f8d2a0eb1368e274b7" // 你的视频地址（必填）
      }
    ],
    poster: "/img/logo.png", // 你的封面地址
    width: document.documentElement.clientWidth,
    notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
    controlBar: {
      timeDivider: true,
      durationDisplay: true,
      remainingTimeDisplay: false,
      fullscreenToggle: true
    }
  };
}
